export enum Mode {
	sms, // 短信验证码
	psw, // 账号密码
}
export enum View {
	login, // 登录
	signup, // 注册
	fill, // 完善信息
}
